<template>
    <v-textarea
        v-if="editMode"
        v-model="modelValue"
        :error="field === fieldWithError"
        :disabled="disabled"
        resize="vertical"
        ref="textarea"
        rows="9"
    />
    <v-markdown
      v-else
      class="markdown"
      :content="value"
    />
</template>

<script>
import detailsViewMixin from '@/mixins/detailsView.js';
import VTextarea from '@/components/VTextarea.vue';
import VMarkdown from '@/components/VMarkdown.vue';

export default {
  mixins: [detailsViewMixin],
  components: {
    VTextarea,
    VMarkdown,
  },
  props: {
    value: String,
    field: String,
    disabled: Boolean,
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  watch: {
    fieldWithError() {
      if (this.field === this.fieldWithError) {
        this.$refs.textarea.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
  },
};
</script>
